import React from 'react';

import { useTranslation } from 'react-i18next';
import { Tag, TagType, Tooltip } from '@bringg/react-components';

import styles from './planning-tag.module.scss';

interface PlanningTagProps {
	routeId: number;
}

const PlanningTag = ({ routeId }: PlanningTagProps) => {
	const { t } = useTranslation();

	return (
		<Tooltip
			title={
				<div className={styles.tagTooltip}>
					<div className={styles.tagTooltipTitle}>{t('MONITORING.PLANNING_TOOLTIP')}</div>
				</div>
			}
		>
			<Tag key={routeId} type={TagType.success} className={styles.tag} data-test-id={`tag-${routeId}`}>
				{t('MAIN.PLANNING').charAt(0)}
			</Tag>
		</Tooltip>
	);
};

export default PlanningTag;
